import { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "@/components/Header";
import LegalBanner from "@/components/LegalBanner";
import Footer from "@/components/Footer";
import { Seo } from "@/lib/seo";

const TOPICS = [
  { path: "/car-affordability-calculator", title: "How much car can you actually afford?", body: "Start with your finances, not the sticker. Our affordability calculator runs the real DriveClear engine across the price range." },
  { path: "/dti-calculator", title: "What a car payment does to your DTI", body: "Lenders watch your debt-to-income ratio. See how a new payment changes it before you sign anything." },
  { path: "/car-cost-of-ownership", title: "The payment is not the cost", body: "Insurance, fuel and maintenance can add hundreds a month. Price the whole picture, not just the loan." },
];

export default function Learn() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="min-h-screen bg-white text-stone-900 font-sans antialiased" data-testid="learn-page">
      <Seo
        title="Learn — Automotive finance, in plain language | DriveClear"
        description="Guides and interactive tools that explain car payments, affordability, DTI and the true cost of owning a vehicle — in plain language."
        path="/learn"
      />
      <LegalBanner />
      <Header />
      <main className="py-16 lg:py-24">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl sm:text-4xl font-extrabold text-stone-900 tracking-tight mb-4">Learn the numbers behind the car.</h1>
          <p className="text-stone-600 text-lg leading-relaxed mb-10">
            Automotive finance, explained through interactive tools rather than walls of text. Full guides are in progress — each topic below starts with the calculator that answers it.
          </p>
          <div className="space-y-4">
            {TOPICS.map((t) => (
              <Link key={t.path} to={t.path} data-testid={`learn-${t.path.slice(1)}`} className="block rounded-2xl bg-[#faf9f7] border border-stone-200 p-6 hover:border-blue-300 hover:bg-white transition-colors">
                <h2 className="text-lg font-bold text-stone-900 mb-1.5">{t.title}</h2>
                <p className="text-sm text-stone-600 leading-relaxed">{t.body}</p>
              </Link>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
